import React from 'react';
import AssessmentSteper from '../../components/ApplicantAssessment/AssessmentStepper';
import { Grid, Typography } from '@mui/material';
import './AssessmentCompletionPage.css';

const AssessmentCompletionPage: React.FC = () => {
  return (
    <Grid container direction="column" sx={{ marginTop: '2vh' }} className='assessment-completion-page'>
      <Typography
        variant="h4" fontWeight="bold"
        sx={{
          color: 'var(--ttg-black)',
          fontFamily: 'inherit',
          marginBottom: '1rem',
          marginTop: '1rem'
        }}
      >
        Complete Your Assessment
      </Typography>
      <AssessmentSteper />
    </Grid>
  );
};

export default AssessmentCompletionPage;
